// import { createType } from 'reducers/utils/helpers';
import { generateTypes } from '../../utils/HttpReducerHelper';

const clientTimeline = generateTypes('MONITOR', 'CLIENT_TIMELINE');
const SSE_UPDATE_SNAPSHOT_TIMELINE_GENERATION_PROGRESS = '@@SSE/entity/ledger/snapshot/timeline';

export { clientTimeline, SSE_UPDATE_SNAPSHOT_TIMELINE_GENERATION_PROGRESS };
